module.exports = __webpack_public_path__ + "static/media/icons-ic-phone-callback.9e726efe.svg";